import React, { useContext, useEffect, useState } from "react";
import style from "../Modal.module.css";
// import ButtonsModal from "./ButtonsModal/ButtonsModal";
import Button from "../../Button/Button.js";
import { QtdContext } from "../../../context/qtdContext.js";
import { BiTrash } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom';
import $api from '../../../http/index.ts'
import { BACKURL } from '../../../conf.js'
import Loading from 'react-fullscreen-loading';
import DatePicker from "react-datepicker";
import { FcEngineering, FcCancel } from "react-icons/fc";
import "react-datepicker/dist/react-datepicker.css";

const EditScladOrderListModal = ({ order_id, prod_id }) => {


  // const produtosCart = JSON.parse(localStorage.getItem("pet"));
  // const { setSclad,setServerProd, auth, setAuth } = useContext(QtdContext);
  const [loading, seloading] = useState(false)
  const [newValue, setNewValue] = useState('')
  const [err, setErr] = useState('')

  const { Notify,setScladOrderListModal,setSclad,editScladOrderListItemModal, setEditScladOrderListItemModal, sclad, setScladOrders, scladOrders, admin } = useContext(QtdContext);
  const closeModal2 = ({ target }) => {
    // console.log(target)
    target.id === "g33jh2hkkqw" && setEditScladOrderListItemModal(false);
    // target.innerText === "ОТМЕНИТЬ" && setModal(false);
  };

  // console.log('order_id, prod_id', order_id, prod_id)
  const prod = sclad.find(pr => pr.id == prod_id)

  const editIt = async (e) => {
    e.preventDefault()
    try {
      let t = ''
      if (newValue <= 0 || newValue == '') {
        t = 'Выберите количество!'
      }
      setErr(t)
      if (!t && newValue) {
        seloading(true)
        // console.log('ask, ', order_id, prod_id, newValue)

        const newProd = await $api.post(`${BACKURL}/api/scladorder/editqty`,
        { order_id,prod_id, newValue: newValue, admin: admin.id }
      )
      setSclad(
        newProd.data.scladall
      )
      setScladOrders( newProd.data.ScladOrderAll)

      seloading(false)

      setEditScladOrderListItemModal(false)
      setScladOrderListModal(false)
      Notify.addNotification({
        title: "Готово!",
        message: "Количество товара в заказе успешно измененно!",
        type: "info",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
      }
    } catch (e) {
      // console.log(e)
      seloading(false)
      Notify.addNotification({
        title: "Ошибка!",
        message: "Произошла непредвиденная ошибка!",
        type: "danger",
        insert: "bottom",
        container: "bottom-center",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      })
    }
  }

  return (
    <>
      {editScladOrderListItemModal && (
        <div onClick={closeModal2} id="g33jh2hkkqw" className={style.modal_container}>

          <div className={style.borders}>


            <div className={style.inputtest}>

              <label >Выберите количество:</label>

              <select name="pets" id="qty"
                value={newValue}
                onChange={(event) => {
                  setNewValue(event.target.value)
                }}
              >
                <option value="">--Выберите количесвто--</option>
                {/* <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option> */}
                
                {prod.step && (<>
                  {[...Array(Number(prod.qty))].map((item, index) => <option value={`${prod.step * (index + 1)}`}>{prod.step * (index + 1)}{prod.mnt}</option>)}
                </>
                )}



              </select>
              {err.qty && (
                <p style={{ color: "red" }}>{err.qty}</p>
              )}
            </div>



            <Button
              text="Изменить"
              background="var(--primary-color)"
              color="white"
            width="100%"
            onClick={editIt}
            />


          </div>

        </div>
      )}
      {loading && (
        <Loading loading background="rgba(255, 165, 0,0.75)" loaderColor="#3498db"></Loading>
      )}
    </>
  );
};

export default EditScladOrderListModal;
